const accessFinance = {
    DUES_AND_PAYMENTS: { name: 'Dues and Payments', path: '/dues-and-payments' },
    FINE_CHARGES_LIST: { name: ' Fine charges Types', path: '/fine-charges-list' },
    FINE_CHARGES_DETAILS: { name: 'Fine Charges Details', path: '/fine-charges-details' },
    ADD_FINE_CHARGES: { name: 'Add Fine Charges', path: '/create-fine-charges' },
    UPDATE_FINE_CHARGES: { name: 'Update Fine Charges', path: '/edit-fine-charges' },
    DELETE_FINE_CHARGES: { name: 'Delete Fine Charges', path: '/delete-fine-charges' },

    INVOICE_LIST: { name: 'Invoice', path: '/invoice-list' },

    PAYMENT_LIST: { name: 'Pending Payment', path: '/payment-list' },
    PAYMENT_DETAILS: { name: 'Payment Details', path: '/payment-details' },
    MANUAL_PAYMENT_ENTRY: { name: 'Manual Payment Entry', path: '/manual-payment-entry' },
    DELETE_PAYMENT_TRANSACTION: { name: 'Delete Payment Transaction', path: '/delete-payment-transaction' },

    EXPENSE_BUDGET: { name: 'Budget Planning', path: '/expense-budget' },

    BUDGET_TRACKING_LIST: { name: 'Budget Tracking', path: '/budget-tracking-list' },

    EXPENSE_LIST: { name: 'Society Expense', path: '/expense-list' },
    EXPENSE_DETAILS: { name: 'Expense Details', path: '/expense-details' },
    ADD_EXPENSE: { name: 'Add Expense', path: '/create-expense' },
    UPDATE_EXPENSE: { name: 'Update Expense', path: '/edit-expense' },
    DELETE_EXPENSE: { name: 'Delete Expense', path: '/delete-expense' },
    FINANCE: { name: 'Finance', path: '/finance' },
}

export default accessFinance;